<template>
  <div v-loading="loading">
    <el-table
      v-if="tableConfig"
      :key="tableKey"
      :data="cars"
      style="width: 100%"
      :default-sort="tableConfig.sort"
    >
      <component
        :is="column.value"
        v-for="column in tableConfig.columns"
        :key="column.value"
      />
      <el-table-column
        fixed="right"
        label=""
        width="130"
        style="text-align: right;"
      >
        <template
          slot="header"
          slot-scope="scope"
        >
          <table-settings
            v-if="tableConfig"
            :config="tableConfig"
            :allcolumns="allColumns"
            :labels="labels"
            storeModule="car"
            :options="['settings']"
          />
        </template>
        <template
          slot-scope="scope"
        >
          <Actions :car="scope.row" />
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import Actions from './Actions';
  import TableSettings from '../../TableSettings';
  import columns, { allColumns, labels } from './columns';

  export default {
    components: {
      Actions,
      TableSettings,
      ...columns,
    },
    data() {
      return {
        labels,
        allColumns,
        tableKey: 0,
      };
    },
    computed: {
      cars() {
        return this.$store.getters['car/cars'];
      },
      tableConfig() {
        return JSON.parse(JSON.stringify(this.$store.getters['car/tableConfig']));
      },
      loading() {
        return this.$store.getters['car/loading'];
      },
    },
    watch: {
      tableConfig() {
        this.tableKey++;
      },
    },
    async mounted() {
      await this.$store.dispatch('car/fetchAll');
    },
  };
</script>
